<template>
  <li
    :class="[
      'year-box',
      { expanded },
      { columnView: $route.query.disposition === 'columns' },
    ]"
    @click="
      $router.push({
        name: 'card',
        query: { ...$route.query, year: year.YEAR, decade },
      })
    "
    :style="{
      'background-color': `var(--${year.CATEGORY.toLowerCase()})`,
    }"
    v-if="
      year.CATEGORY.toLowerCase() === $route.query.category ||
      $route.query.category === undefined
    "
  >
    <div
      v-if="$route.query.disposition !== 'columns'"
      :style="{
        display: 'flex',
        width: tvaMq === 'desktop' ? '100%' : null,
      }"
    >
      <span :class="['year-box__label', { expanded }]">{{ year.YEAR }}</span>
      <div v-if="expanded" class="year-box__wrapper">
        <p class="year-box__wrapper__title">{{ expanded.TITLE }}</p>
        <p class="year-box__wrapper__subtitle">{{ expanded.SUBTITLE }}</p>
      </div>
    </div>
    <div
      v-if="$route.query.disposition === 'columns'"
      class="year-box__wrapper"
    >
      <p class="year-box__wrapper__year">{{ year.YEAR }}</p>
      <p
        :class="[
          'year-box__wrapper__title',
          {
            special:
              year.EVENTS[0].TITLE.toLowerCase().includes('approvvigionamento'),
          },
        ]"
      >
        {{ year.EVENTS[0].TITLE }}
      </p>
      <p class="year-box__wrapper__subtitle">{{ year.EVENTS[0].SUBTITLE }}</p>
    </div>
    <div
      class="year-box__image"
      :style="{
        backgroundImage: `url(${`${$baseUrl}thumbnails/${
          tvaMq === 'mobile' || tvaMq === 'tablet'
            ? `${year.THUMB}-s`
            : year.THUMB
        }.webp`})`,
      }"
      :alt="'card-' + year.THUMB"
      v-if="tvaMq === 'desktop' || $route.query.disposition === 'columns'"
    />
  </li>
</template>

<script setup>
import { computed } from "@vue/reactivity";
import { inject } from "vue";

const tvaMq = inject("$tvaMq");
const props = defineProps({
  year: Object,
  decade: Number,
});

const expanded = computed(() =>
  props.year.EVENTS.find((item) => item.EXPANDED == true)
);
</script>

<style lang="scss" scoped>
.year-box {
  height: toRem(120);
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  transition: box-shadow 0.3s ease;
  background-position: center center;
  @include video-shadow;

  &.expanded {
    grid-column: span 2;

    .year-box__image {
      min-width: 25%;
    }
  }

  &:not(.columnView) {
  }

  &.columnView {
    grid-column: auto;
    height: toRem(300);

    .year-box__image {
      min-width: 45%;
    }

    .year-box__wrapper {
      height: 100%;
      max-width: 60%;
      background-size: cover;
      margin: 0;
      padding: toRem(19) toRem(18);
      display: flex;
      flex-direction: column;

      &__year {
        @include numeri-s;
        margin-bottom: auto;
      }

      &__title {
        @include tasselli-titolo-big;

        &.special {
          word-break: break-word;
        }
      }

      &__subtitle {
        margin-top: toRem(9);
        @include p-m;
      }

      &::before {
        content: unset;
      }
    }
  }

  &__label {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $scala-grigi-white;
    @include title-h-0;
    margin-right: auto;
    margin-left: auto;

    &.expanded {
      margin-left: 27px;
    }
  }

  &__image {
    min-width: 50%;
    background-size: cover;
    background-position: 50%;
  }

  &__wrapper {
    text-align: left;
    color: $scala-grigi-white;
    margin: auto;
    padding: 0 toRem(27);
    position: relative;

    &__title {
      @include tasselli-titolo;
    }

    &__subtitle {
      margin-top: toRem(9);
      @include tasselli-testo;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 13.5px;
      height: 100%;
      width: 1px;
      background-color: $scala-grigi-white;
    }
  }

  &:hover {
    @include shadow-year-highlight;
  }
}

.tablet,
.mobile {
  .year-box {
    height: toRem(120);

    &.columnView {
      height: toRem(188);

      .year-box__image {
        min-width: 45%;
      }

      .year-box__wrapper {
        padding: toRem(10);

        &__year {
          @include numeri-xs;
        }

        &__title {
          @include tasselli-titolo-m;
        }

        &__subtitle {
          margin-top: toRem(5);
          @include tasselli-testo;
        }
      }
    }

    &__wrapper {
      padding: 0 toRem(10);

      &__title {
        @include tasselli-titolo-s;
      }

      &__subtitle {
        margin-top: toRem(3);
        @include tasselli-testo-s;
      }

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        height: toRem(24);
        transform: translateY(-50%);
      }
    }

    &__label {
      padding: 0 toRem(12);
      @include title-h-4;

      &.expanded {
        margin-left: 0;
      }
    }
  }
}

.mobile {
  .year-box {
    &.columnView {
      height: toRem(170);

      .year-box__wrapper {
        &__year {
          @include numeri-xs;
        }

        &__title {
          @include tasselli-titolo-s;
        }

        &__subtitle {
          margin-top: toRem(5);
          @include tasselli-testo-s;
        }
      }
    }
  }
}
</style>
